import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { afterShellPaint } from '@/lib/shellPaint'

import { App } from './App'
import { loadLoginPage, loadMagicLoginPage } from './pages/loaders'
import './styles/index.css'

const root = document.getElementById('root')!
// index.html paints the sign-in gate (GateShell's markup) for a visitor who was
// signed out last time; its title is the page's Largest Contentful Paint.
const shellTitle = root.querySelector('.bl-gate-title')

// The visitor's likely page loads alongside the session check, not after it.
// A failed load surfaces when the route renders (RoutePage's reload prompt).
if (/^\/t\//i.test(window.location.pathname)) void loadMagicLoginPage()
else if (shellTitle) void loadLoginPage()

// React replaces the static gate with the same markup. Render once the browser
// has recorded that paint (at once on a slow phone; see src/lib/shellPaint.ts (kept in sync with apps/shared/shellPaint.ts)),
// or after 300 ms.
void afterShellPaint(shellTitle, 300).then(() => {
  createRoot(root).render(
    <StrictMode>
      <App gate={shellTitle !== null} />
    </StrictMode>,
  )
})
